import { __assign } from "tslib";
import React from 'react';
import { View, TouchableOpacity, Platform } from 'react-native';
import moment from 'moment';
// Custom
import PnmacTextMobile from '../Typography/PnmacTextMobile';
import { textStyle } from '../v2/theme';
var Date = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s(props).date
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: textStyle.formBody,
    heavy: true,
    gray: true,
    center: true,
    size: 11,
    mb: -2
  }, moment(props.date).format('MMM').toUpperCase()), /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: textStyle.formBody,
    heavy: true,
    gray: true,
    center: true,
    size: 17
  }, moment(props.date).format('DD')));
};
var Details = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s(props).details
  }, /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: textStyle.formBody,
    heavy: true,
    darkGray: true,
    size: 15,
    mb: 2,
    ellipsizeMode: 'tail',
    numberOfLines: 1
  }, props.mainInfo), /*#__PURE__*/React.createElement(PnmacTextMobile, {
    style: textStyle.formBody,
    heavy: true,
    gray: true,
    size: 11,
    ellipsizeMode: props.secondaryInfoEllipsizeMode ? props.secondaryInfoEllipsizeMode : 'middle',
    numberOfLines: 1
  }, props.secondaryInfo));
};
var Right = function (props) {
  return /*#__PURE__*/React.createElement(View, {
    style: s(props).right
  }, props.rightInfo);
};
var PnmacActivityRow = function (props) {
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: s(props).container,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(Date, __assign({}, props)), /*#__PURE__*/React.createElement(Details, __assign({}, props)), /*#__PURE__*/React.createElement(Right, __assign({}, props)));
};
export default PnmacActivityRow;
var s = function (props) {
  return {
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      topLeftBorderRadius: props.topLeftBorderRadius,
      topRightBorderRadius: props.topRightBorderRadius
    },
    date: {
      paddingTop: 12,
      paddingBottom: 8,
      paddingLeft: 5,
      paddingRight: 5,
      alignItems: 'center',
      width: 60,
      fontFamily: Platform.OS == "web" ? 'inherit' : 'gilroy',
      fontWeight: 700
    },
    details: {
      flex: 1,
      paddingVertical: 9
    },
    right: {
      paddingRight: 20,
      paddingLeft: 10
    }
  };
};